import { useParametrosMensualesHorasExtrasContext } from 'Context/ParametrosMensualesHorasExtrasContext'
import React, { useCallback, useState } from 'react'
import { Row, Col, Button } from "reactstrap"
import { DetalleParametrosPlanificacionHE, DetalleParametrosRegimenProyeccionHE } from '../TypesParametrosHorasExtras'
import Cargando from 'components/Varios/Cargando'
import CardPeriodosPlanificacionHE from './CardPeriodosPlanificacionHE'
import { ActualizarParametrosPlanificacion, ConsultarDetalleParametrosMensualesAnio, CrearParametrosPlanificacion } from '../FunctionsParametrosHE'
import { showAlert } from '../Actividades/ActividadesHorasExtras'
import { PruebaSolucion2 } from 'functions/DatesFunctions'
import CardNroHorasPlanificacion from './CardNroHorasPlanificacion'

type PropsParametrosPlanif = {
    parametrosPlanificacion: DetalleParametrosPlanificacionHE | null | undefined,
    anioParametros: number | undefined
}

export default function ParametrosPlanificacion(props: PropsParametrosPlanif) {

    const { parametrosPlanificacion, anioParametros } = props

    const [informacionGeneralParametros, setinformacionGeneralParametros] = useState<DetalleParametrosPlanificacionHE | null | undefined>(parametrosPlanificacion);

    const {
        guardandoParametro,
        setguardandoParametro,
        setparametrosHorasRegimen,
        parametrosHorasRegimen,
        creandoParametros,
        setcreandoParametros
    } = useParametrosMensualesHorasExtrasContext();

    const onChangeDiasRecepcion = useCallback((valor: any, tipo: string) => {
        if (!informacionGeneralParametros && anioParametros) {
            var nuevosParametros: DetalleParametrosPlanificacionHE = {
                anio: anioParametros,
                listadoparametroshorasregimen: [],
                diaMaximoRecepcionPlanificacion: null,
                diaMaximoRecepcionSolicitud: null,
                presupuestoAnualAsignado: null,
                fechaMaximaPeriodoExtr: null,
                mesPeriodoExtr: null,
                minMinutosHorExtr:null

            }

            if (tipo === "P") {
                if (typeof (valor) === 'number' && valor) {
                    nuevosParametros.diaMaximoRecepcionPlanificacion = valor;
                }
                else {
                    nuevosParametros.diaMaximoRecepcionPlanificacion = null;
                }

            }

            if (tipo === "S") {
                if (typeof (valor) === 'number' && valor) {
                    nuevosParametros.diaMaximoRecepcionSolicitud = valor;
                }
                else {
                    nuevosParametros.diaMaximoRecepcionSolicitud = null;
                }
            }

            if (tipo === "M") {
                if (typeof (valor) === 'number' && valor) {
                    nuevosParametros.minMinutosHorExtr = valor;
                }
                else {
                    nuevosParametros.minMinutosHorExtr = null;
                }
            }




            if (tipo === "PE" && typeof (valor) === 'number' && valor) {
                nuevosParametros.mesPeriodoExtr = valor;
            }
            else if (tipo === "PE") {
                nuevosParametros.mesPeriodoExtr = null;
            }

            if (tipo === "PEF" && typeof (valor) === 'string' && valor) {
                nuevosParametros.fechaMaximaPeriodoExtr = valor;
            }
            else if (tipo === "PEF") {

                nuevosParametros.fechaMaximaPeriodoExtr = null;
            }

            setinformacionGeneralParametros(nuevosParametros);


        }
        else if (informacionGeneralParametros) {
            var copiaInformacionGeneralParametros: DetalleParametrosPlanificacionHE = { ...informacionGeneralParametros }

            if (tipo === "P" && typeof (valor) === 'number' && valor) {
                copiaInformacionGeneralParametros.diaMaximoRecepcionPlanificacion = valor;
            }
            else if (tipo === "P") {
                copiaInformacionGeneralParametros.diaMaximoRecepcionPlanificacion = null;
            }

            if (tipo === "S" && typeof (valor) === 'number' && valor) {
                copiaInformacionGeneralParametros.diaMaximoRecepcionSolicitud = valor;
            }
            else if (tipo === "S") {
                copiaInformacionGeneralParametros.diaMaximoRecepcionSolicitud = null;
            }

            if (tipo === "PE" && typeof (valor) === 'number' && valor) {
                copiaInformacionGeneralParametros.mesPeriodoExtr = valor;
            }
            else if (tipo === "PE") {
                copiaInformacionGeneralParametros.mesPeriodoExtr = null;
            }

            if (tipo === "PEF" && typeof (valor) === 'string' && valor) {
                copiaInformacionGeneralParametros.fechaMaximaPeriodoExtr = valor;
            }
            else if (tipo === "PEF") {

                copiaInformacionGeneralParametros.fechaMaximaPeriodoExtr = null;
            }

            if (tipo === "M" && typeof (valor) === 'number' && valor) {
                copiaInformacionGeneralParametros.minMinutosHorExtr = valor;
            }
            else if (tipo === "M") {
                copiaInformacionGeneralParametros.minMinutosHorExtr = null;
            }

            setinformacionGeneralParametros(copiaInformacionGeneralParametros);

        }
    }, [informacionGeneralParametros])

    async function ConsultarDetalle(anioSeleccionado: number) {
        const detalleParametros = await ConsultarDetalleParametrosMensualesAnio(anioSeleccionado);
        if (detalleParametros.status === 200 && detalleParametros.dataResponse) {


            setinformacionGeneralParametros(detalleParametros.dataResponse)
            setparametrosHorasRegimen(detalleParametros.dataResponse.listadoparametroshorasregimen)

        }
        else if(detalleParametros.status === 401){
            showAlert("Su usuario no se encuentra autorizado para verificar la información", false)
        }
        else if (detalleParametros.status === 204) {
            setinformacionGeneralParametros(null)
            setparametrosHorasRegimen(null)

        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al consultar detalle de parámetros de planificación"
            showAlert(detalleParametros.errorMessage ?? mensajeDefault, false)
        }
    }


    async function ActualizarParametros(informacionGeneralParametros: DetalleParametrosPlanificacionHE | null | undefined, parametrosHoras: DetalleParametrosRegimenProyeccionHE[] | null) {
        if (informacionGeneralParametros) {
            setguardandoParametro(true);
            var copiaInformacionGeneral: DetalleParametrosPlanificacionHE = { ...informacionGeneralParametros };

            if (parametrosHoras != null) {
                if(parametrosHoras.find(hr => (!hr.horasextraordinarias) && !hr.horassuplementarias && !hr.horassuplyextr) !== undefined){
                    showAlert("Debe indicar los valores de nro de Horas para poder guardar los parámetros", false);
                    setguardandoParametro(false);
                    return
                }
                copiaInformacionGeneral.listadoparametroshorasregimen = parametrosHoras;
            }

            if (copiaInformacionGeneral.fechaMaximaPeriodoExtr) {
                const fecha = new Date(copiaInformacionGeneral.fechaMaximaPeriodoExtr)
                copiaInformacionGeneral.fechaMaximaPeriodoExtr = PruebaSolucion2(fecha);
            }


            const respuesta = await ActualizarParametrosPlanificacion(copiaInformacionGeneral);
            if (respuesta.status === 200 || respuesta.status === 204) {
                showAlert("Se han actualizado los parámetros sin novedad", true)
                await ConsultarDetalle(informacionGeneralParametros.anio);

            }
            else if(respuesta.status === 401){
                showAlert("Su usuario no se encuentra autorizado para realizar esta acción", false)
            }
            else {
                const mensajeDefault = "Ha ocurrido un inconveniente al intentar actualizar los parámetros"
                showAlert(respuesta.errorMessage ?? mensajeDefault, false)
            }

            setguardandoParametro(false);

        }

    }


    async function CrearParametros(informacionGeneralParametros: DetalleParametrosPlanificacionHE | null | undefined, parametrosHoras: DetalleParametrosRegimenProyeccionHE[] | null) {

        if (informacionGeneralParametros) {
            setcreandoParametros(true)

            var copiaInformacionGeneral = { ...informacionGeneralParametros };



            if (parametrosHorasRegimen !== null) {
                copiaInformacionGeneral.listadoparametroshorasregimen = parametrosHorasRegimen;
            }

            const respuesta = await CrearParametrosPlanificacion(copiaInformacionGeneral);
            if (respuesta.status === 200 || respuesta.status === 204) {
                showAlert("Se han agregado/actualizado los parámetros sin novedad", true)
                ConsultarDetalle(informacionGeneralParametros.anio);

            }
            else if(respuesta.status === 401){
                showAlert("Su usuario no se encuentra autorizado para realizar esta acción", false)
            }
            else {
                const mensajeDefault = "Ha ocurrido un evento inesperado. Intente más tarde."
                showAlert(respuesta.errorMessage ?? mensajeDefault, false)
            }

            setcreandoParametros(false)
        }
        else {
            showAlert("Debe indicar los días de recepción para poder guardar los parámetros",false)
        }
    }


    console.log(parametrosHorasRegimen)

    return (
        <React.Fragment>
            <Row className="mt-4">
                <Col xl={12}>
                    <div className="tituloTipoParametroHE">{"PLANIFICACIÓN " + props.anioParametros}</div>
                </Col>
            </Row>

            {/* {
                informacionGeneralParametros && <>
                    <div>diaMaxRecepPlanif</div>
                    <div>
                        {informacionGeneralParametros.diaMaximoRecepcionPlanificacion?.toString()}
                    </div>
                    <div>diaMaxRecpSolic</div>
                    <div>
                        {informacionGeneralParametros.diaMaximoRecepcionSolicitud?.toString()}

                    </div>
                    <div>
                        MES EXTR
                    </div>
                    <div>
                        {informacionGeneralParametros.mesPeriodoExtr?.toString()}
                    </div>
                    <div>FECHA EXTR</div>
                    <div>
                        {informacionGeneralParametros.fechaMaximaPeriodoExtr?.toString()}
                    </div>
                </>
            } */}

            {
                (guardandoParametro || creandoParametros) &&
                <Row>
                    <Col xl={12}>
                        <Cargando mensaje='Guardando parametros' />
                    </Col>
                </Row>
            }
            {
            (!guardandoParametro && !creandoParametros )&&
                <React.Fragment>
                    <Row>
                        <Col xl={6}>
                            <CardPeriodosPlanificacionHE
                                parametros={informacionGeneralParametros}
                                onChangeValorDias={(valor: any, tipo: string) => { onChangeDiasRecepcion(valor, tipo) }}
                            />

                        </Col>
                        <Col xl={6} className={""}>
                            <CardNroHorasPlanificacion
                                parametros={informacionGeneralParametros}
                            />
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col xl={12}>
                            <div style={{ display: "flex", justifyContent: "center" }}>


                                {
                                    informacionGeneralParametros?.valoresConsultados ?
                                        <Button
                                            onClick={() => ActualizarParametros(informacionGeneralParametros, parametrosHorasRegimen)}
                                            color="secondary"
                                            disabled={guardandoParametro}
                                        >
                                            Guardar
                                        </Button>
                                        :
                                        <Button
                                            onClick={() => CrearParametros(informacionGeneralParametros, parametrosHorasRegimen)}
                                            color="secondary"
                                            disabled={creandoParametros}
                                        >
                                            Guardar
                                        </Button>
                                }


                            </div>

                        </Col>
                    </Row>
                </React.Fragment>
            }
        </React.Fragment>
    )
}
